// extracted by mini-css-extract-plugin
module.exports = {"mainViewContainer":"SearchResult_mainViewContainer__2p8pN","pageHeaderText":"SearchResult_pageHeaderText__2KT-J"};